import * as React from 'react'
import { Box, Typography, Link } from '@mui/material'
import BubbleChartOutlinedIcon from '@mui/icons-material/BubbleChartOutlined'
import { emitEvent } from '../components/LeftMenuMigration/legacyBridge'
import { useZustand } from '../hooks/useZustand'

// The overlay is pointer-transparent so the graph stays interactive;
// inline action links opt back in.
const actionLinkSx = {
    pointerEvents: 'auto',
    userSelect: 'auto',
    verticalAlign: 'baseline',
    font: 'inherit',
    color: 'inherit',
    textDecorationColor: 'currentColor',
}

/**
 * Centered "your graph is empty" overlay.
 *
 * @param {Function} [onImportClick] — when provided (the first-entry flow:
 *     the user closed the auto-opened import dialog), an extra
 *     "import data" action is shown that reopens that dialog.
 */
function GraphEmptyState({ onImportClick }) {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: '50%',
                zIndex: theme => theme.zIndex.drawer - 1,
                transform: 'translateY(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                justifyContent: 'center',
                width: '100%',
                pointerEvents: 'none',
                userSelect: 'none',
                color: 'text.secondary',
            }}
        >
            <BubbleChartOutlinedIcon sx={{ fontSize: 56, opacity: 0.3 }} />
            <Typography
                variant="h6"
                color="text.primary"
                sx={{ opacity: 0.45, textAlign: 'center' }}
            >
                <Link
                    component="button"
                    type="button"
                    onClick={() =>
                        useZustand.getState().requestAddStatement()
                    }
                    sx={actionLinkSx}
                >
                    Add statements
                </Link>{' '}
                {onImportClick && (
                    <>
                        or{' '}
                        <Link
                            component="button"
                            type="button"
                            onClick={onImportClick}
                            sx={actionLinkSx}
                        >
                            import data
                        </Link>
                    </>
                )}{' '}
                to build your graph
                <br></br>
                if content exists,{' '}
                <Link
                    component="button"
                    type="button"
                    onClick={() => emitEvent('showLanguageSettings')}
                    sx={actionLinkSx}
                >
                    change text processing settings
                </Link>{' '}
                to "words and entities"
            </Typography>
        </Box>
    )
}

export default GraphEmptyState
